var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.CreationWizard,{attrs:{"mode":"workflow","initialState":_setup.props,"embeddedMode":""},on:{"close-wizard":_setup.close,"start-creation-process":_setup.startCreationProcess}})
}
var staticRenderFns = []

export { render, staticRenderFns }